import React, { useState, useEffect, memo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { parseAutoExtendConfig } from "../../../utils/autoExtendConfig";

const CountdownTimer = ({
    onTimerEnd,
    autoExtendConfig = parseAutoExtendConfig(),
    ...data
}) => {
    const [endTime, setEndTime] = useState(() => data?.until ? Date.now() + data.until : null);
    const [timeRemaining, setTimeRemaining] = useState(data?.until || 0);
        const bidCenterData = useSelector((state) => state.pdp.bidCenterData);
    const pdpInitData = useSelector((state) => state.pdp.pdpInitData);



    const ownItNowEnabled = pdpInitData?.listingDetail?.ownItNowFlag;

    useEffect(() => {
        if (!data?.until) return;

        const newEndTime = Date.now() + data?.until;
        setEndTime(newEndTime);
    }, [data?.until]);

   
    useEffect(() => {
        if (!endTime) return;

        const updateTimer = () => {
            const now = Date.now();
            const remaining = endTime - now;
            const newTimeRemaining = Math.max(0, remaining);
            setTimeRemaining(newTimeRemaining);
            
            if (newTimeRemaining === 0 && onTimerEnd) {
                onTimerEnd();
            }
        };

        updateTimer(); // Set immediately
        const interval = setInterval(updateTimer, 1000);

        return () => clearInterval(interval);
    }, [endTime, onTimerEnd]);

    const formatTime = (time) => {
        const seconds = Math.floor((time / 1000) % 60);
        const minutes = Math.floor((time / (1000 * 60)) % 60);
        const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
        const days = Math.floor(time / (1000 * 60 * 60 * 24));
        const shouldshowInRed = autoExtendConfig.isAutoExtendActive && time < autoExtendConfig.autoExtendWindowMs;


        return (
            <>
             {data?.shouldShowLabel === 'Y' &&
                    <div className="text-center bid-heading-ends">
                        {shouldshowInRed && autoExtendConfig.isAutoExtendActive ?
                        <div className="col text-center">
                                <div className="pb20">
                            <p className="tdu text-center" style={{whiteSpace: "nowrap", fontSize: 16, fontFamily:"graphikregular", margin: "0 auto", borderBottom: "none", textDecoration: "underline", textDecorationStyle: "dashed"}} data-tooltip-id="lastMinRule"
                                data-tooltip-place="bottom"
                                data-tooltip-content={autoExtendConfig.autoExtendText}
                            >Last {autoExtendConfig.autoExtendWindow} Min Rule</p><Tooltip  id="lastMinRule" place="bottom"
                                
                                style={{ width: 400, zIndex: 9999, fontSize: 11, lineHeight:1.5, textAlign: "left" }} /></div>
                                {pdpInitData.propertyDetails.commonAttributes.propCategory === "COMMERCIAL" ? "" : "AUCTION ENDS IN"}
                                </div>
                                
                                :
                                pdpInitData.propertyDetails.commonAttributes.propCategory === "COMMERCIAL" ? "" : "AUCTION ENDS IN"

                        }
                    </div>
                }
                 <div className="mt10 mb20 align-items-center d-flex">

                     <div className="cols mr10">
                         <span className={`pdp-counter-digits  text-center mb0 ${shouldshowInRed  ? "text-red" : "text-blue"}`}>
                             {days.toString().padStart(2, "0")}
                         </span>
                         <span className="pdp-counter-label  text-center mb0">Days</span>
                     </div>
                     <span className=" text-center mb0 pdp-counter-dots">:</span>
                     <div className="cols ml10 mr10">
                         <span className={`pdp-counter-digits  text-center mb0 ${shouldshowInRed ? "text-red" : "text-blue"}`}>
                             {hours.toString().padStart(2, "0")}
                         </span>
                         <span className="pdp-counter-label  text-center mb0">Hours</span>
                     </div>
                     <span className=" text-center mb0 pdp-counter-dots">:</span>
                     <div className="cols ml10">
                         <span
                            className={`pdp-counter-digits  text-center mb0 ${shouldshowInRed ? "text-red" : "text-blue"}`}
                        >
                            {minutes.toString().padStart(2, "0")}
                        </span>
                        <span className="pdp-counter-label  text-center mb0">Mins</span>
                    </div>
                    <span className=" text-center mb0 pdp-counter-dots">:</span>
                    <div className="cols ml10">
                        <span className={`pdp-counter-digits  text-center mb0 ${shouldshowInRed ? "text-red" : "text-blue"}`}>
                            {seconds.toString().padStart(2, "0")}
                        </span>
                        <span className="pdp-counter-label  text-center mb0">Secs</span>
                    </div>
                </div>
                </>

          
        );
    };

    return (
        <div className="countdown-timer-container center">
            {formatTime(timeRemaining)}
        </div>
    );
};

export default memo(CountdownTimer);
